//This is a functional component implored for most customized buttons on this website
function Buttons (props) {

    return (
        <div className='buttons'>
            <button id={props.id} onClick={props.onClick} onDoubleClick={props.onDoubleClick} onClickCapture={props.onSet} onMouseOver={props.onMouseMove}>
                {props.title}
            </button>
        </div>
    )
}

export default Buttons